import { render, staticRenderFns } from "./change-password-form.vue?vue&type=template&id=6d5d7cf0&"
import script from "./change-password-form.vue?vue&type=script&lang=ts&"
export * from "./change-password-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports